module.exports = __webpack_public_path__ + "img/trx.11e2078e.png";